var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.25,
  stroke: "#FFE600",
  strokeWidth: 1.5
});
var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#C4C4C4"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.53905 10.0559V11.6559L3.60572 12.6986C3.26575 12.8208 2.97172 13.0449 2.76367 13.3402M13.2293 13.3411C13.0212 13.0462 12.727 12.8227 12.3871 12.7012L9.45372 11.6559V9.94922",
  stroke: "#FFE600",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.8294 6.65067C10.7308 6.664 10.6534 6.65067 10.5628 6.68C9.56811 6.872 8.93078 6.50933 8.38145 5.552C8.05345 6.18134 7.02678 6.68 6.18145 6.68C5.78823 6.68671 5.39956 6.59504 5.05078 6.41334",
  stroke: "#FFE600",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.92781 10.4748C9.54048 10.4748 10.8478 8.906 10.8478 6.9708C10.8478 5.03559 9.54048 3.4668 7.92781 3.4668C6.31514 3.4668 5.00781 5.03559 5.00781 6.9708C5.00781 8.906 6.31514 10.4748 7.92781 10.4748Z",
  stroke: "#FFE600",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
}));
function SvgIcon16Customer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16Customer);
export default __webpack_public_path__ + "static/media/icon-16-customer.1c99e680.svg";
export { ForwardRef as ReactComponent };